import React from 'react'
import './mass-email-popup.css'
import { MdArrowBack, MdArrowForward, MdClose } from 'react-icons/md'
import { convertSchoolAbbreviationsToNames, createEllipses, createSchoolLogoLinkFromAbbreviation } from '../../utilityFunctions'
import WarningPopup from '../../DanitComponents/Modals/WarningPopup/WarningPopup'
import axios from 'axios'
import { baseUrl } from '../../assets/Animations'
import { getRequestHeaders } from '../../api'
import SimpleNotification from '../../DanitComponents/Notifications/SimpleNotification'
const MassEmailPopup = ({statusOptions, schools, students, teachers, setMassEmailPopup, setSimpleNotification, simpleNotifaction}) => {

    const statusStyles = (status) => {
        if (status === "Active") {
          return { color: "#14B8A6", backgroundColor: "#CCFBF1", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Being Onboarded") {
          return { color: "#3B82F6", backgroundColor: "#DBEAFE", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Waitlist") {
          return { color: "#F59E0B", backgroundColor: "#FEF3C7", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Taking a Break") {
          return { color: "#D946EF", backgroundColor: "#FAE8FF", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Summer Break") {
          return { color: "orange", backgroundColor: "#FEEBC8", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Follow Up") {
          return { color: "red", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Scholarship") {
          return { color: "red", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Needs New Teacher") {
          return { color: "red", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Left the School") {
          return { color: "#EF4444", backgroundColor: "#FEE2E2", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Left For Now") {
          return { color: "#EF4444", backgroundColor: "#FEE2E2", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Left - Permanently") {
          return { color: "#EF4444", backgroundColor: "#FEE2E2", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else if (status === "Inquired") {
          return { color: "#EF4444", backgroundColor: "#FEE2E2", fontSize: "12px", padding: "4px 8px", display: 'inline-block', borderRadius: '4px' };
        } else {
          return { color: "black" };
        }
      }

    const [step, setStep] = React.useState(1)
    const [selectedStatus, setSelectedStatus] = React.useState('')
    const [selectedSchool, setSelectedSchool] = React.useState('')
    const [selectedTeacher, setSelectedTeacher] = React.useState('')
    const [tableDetails, setTableDetails] = React.useState([
        {label: 'First Name', value: 'primaryParentName', editable: true},
        {label: 'Last Name', value: 'familyName', editable: true},
        {label: 'Email', value: 'primaryEmail', editable: true},
        {label: 'Teacher', value: 'findTeacher', editable: false},
        {label: 'School', value: 'school', editable: false},
        {label: 'Status', value: 'familyStatus', editable: false},
    ])
    const [filteredFamilies, setFilteredFamilies] = React.useState([])
    const [warningPopup, setWarningPopup] = React.useState(false)
    const [tryingToSendEmail, setTryingToSendEmail] = React.useState(false)

    const returnFamilyWithStatus = React.useCallback((family) => {
        let studentStatuses = family.students.map(student => student.studentStatus);
        return studentStatuses.includes(selectedStatus);
    }, [selectedStatus]);

    const addTeacherToFamily = React.useCallback((family) => {
        family.students.forEach(student => {
            let teacher = teachers.find(teacher => teacher.TeacherID === student.teachersId)
            student.teacher = teacher
        })
        return family
    }, [teachers])

    React.useEffect(() => {
        let filteredData = students.map((family) => addTeacherToFamily(family))
    
        // if (selectedSchool !== 'All Schools') {
        //     filteredData = filteredData.filter(student => student.school === selectedSchool.toUpperCase());
        // }
    
        if (selectedStatus !== 'All Statuses') {
            filteredData = filteredData.filter(student => returnFamilyWithStatus(student));
        }

        if (selectedTeacher !== '') {
            filteredData = filteredData.filter(student => {
                let found = false
                student.students.forEach(student => {
                    if(student.teachersId === selectedTeacher) {
                        found = true
                    }
                }
                )
                return found
            })
        }
    
        setFilteredFamilies(filteredData);
    }, [students, selectedSchool, selectedStatus, selectedTeacher, returnFamilyWithStatus, addTeacherToFamily]);

    const removeFamily = (familyId) => {
        let newFilteredFamilies = filteredFamilies.filter(family => family.familyId !== familyId)
        setFilteredFamilies(newFilteredFamilies)
    }

    const alphabetizeTeachers = (teachers) => {
        return teachers.sort((a, b) => a.Name.localeCompare(b.Name))
    }

    const editFamilyInformation = (familyId, field, value) => {
        let newFilteredFamilies = filteredFamilies.map(family => {
            if(family.familyId === familyId) {
                family[field] = value
            }
            return family
        })
        setFilteredFamilies(newFilteredFamilies)
    }

    const calculateTeachersForFamily = (family) => {
        let teacherArray = [];
        let foundTeachers = {}
        for(let i = 0; i < family.students.length; i++) {
          if(family.students[i].teachersId) {
            if(!foundTeachers[family.students[i].teachersId]) {
              teacherArray.push(convertTeacherIdIntoTeacherNameAndImage(family.students[i].teachersId))
              foundTeachers[family.students[i].teachersId] = true
            }
          }
        }
        return teacherArray
      }
    
      const convertTeacherIdIntoTeacherNameAndImage = (teacherId) => {
        for(let i = 0; i < teachers.length; i++) {
          if(teachers[i].TeacherID === teacherId) {
            return {name: teachers[i].Name, image: `https://app.atharo.app/images/${teachers[i].ImageName}`}
          }
        }
        return {name: 'Old Teacher', image: `https://app.atharo.app/images/mma.jpg`}
      }

      const sendEmailWarning = () => {
        setWarningPopup({
            type: 'confirm',
            title: 'Are you sure you want to send this mass email?',
            message: 'This will send an email to all the families listed below.',
            onCancel: {
                text: 'Go back',
                action: () => setWarningPopup(false)
            },
            onConfirm: {
                text: 'Yes, Send Email',
                action: () => tryingToSendEmail ? null : sendMassEmail()
            } 
        })
    }

    const sendMassEmail = () => {
        //set cursor to loading
        window.document.body.style.cursor = 'wait'
        setTryingToSendEmail(true)

        let massEmailData = []
        for(let i = 0; i < filteredFamilies.length; i++) {
            let family = filteredFamilies[i]
            let objectForEmail = {}
            objectForEmail.firstName = family.primaryParentName
            objectForEmail.familyEmail = family.primaryEmail
            objectForEmail.schoolName = convertSchoolAbbreviationsToNames(family.school.toLocaleLowerCase())
            objectForEmail.logoLink = createSchoolLogoLinkFromAbbreviation(family.school.toLocaleLowerCase())
            let teacherName = teachers.find(teacher => teacher.TeacherID === selectedTeacher).Name
            let schoolName = convertSchoolAbbreviationsToNames(family.school.toLocaleLowerCase())
            objectForEmail.link = {
                linkText: `Click here to leave ${teacherName} feedback`,
                linkAhref: `https://${schoolName.split(' ')[0].toLocaleLowerCase()}.atharo.app/teacher-assessment/${family.familyId}/${selectedTeacher}`
            }

            massEmailData.push(objectForEmail)

            //let theLink = `https://${schoolName}.atharo.app/teacher-assessment/${family.familyId}/${family.students[0].teachersId}`
            //console.log(theLink)
        }

        axios.post(`${baseUrl}/send-mass-email`, {
            massEmailData: massEmailData 
        }, getRequestHeaders())
        .then((res) => {
            if(res.status === 201) {
                setSimpleNotification({
                    title: `${massEmailData.length} Emails have been sent.`, 
                    subtitle: 'Yay! You did it!', 
                    show: true,
                    style: {
                        backgroundColor: 'bg-green-100',
                        titleColor: 'text-green-800',
                        subtitleColor: 'text-green-800'
                    },
                    approved: true,
                    action: function() {
                        setSimpleNotification(prev => ({...prev, show: false}));
                    }
                })
                window.document.body.style.cursor = 'default'
                setTryingToSendEmail(false)
                setMassEmailPopup(false)
            } else {
                setSimpleNotification({
                    title: `Please check mandrill.com the emails might not have sent`, 
                    subtitle: 'Sorry! Something went wrong.', 
                    show: true,
                    style: {
                        backgroundColor: 'bg-red-100',
                        titleColor: 'text-red-800',
                        subtitleColor: 'text-red-800'
                    },
                    approved: false,
                    action: function() {
                        setSimpleNotification(prev => ({...prev, show: false}));
                    }
                })
                window.document.body.style.cursor = 'default'
                setTryingToSendEmail(false)
                setMassEmailPopup(false)
            }
        })
    }

    return (
        <div className="mass-email-popup__wrapper">
            {warningPopup && <WarningPopup warningPopup={warningPopup}  />}
            <SimpleNotification title={simpleNotifaction.title} subtitle={simpleNotifaction.subtitle} action={simpleNotifaction.action} show={simpleNotifaction.show} style={simpleNotifaction.style} approved={simpleNotifaction.approved} />
            {tryingToSendEmail ? <div className='mass-email-popup__submitting'>Sending Emails...</div>
            :    
            <div className="mass-email-popup__modal">
            {step === 1 && 
            <div>
                <div className='mass-email-popup__close-wrapper'>
                    <MdClose onClick={() => setMassEmailPopup(false)} color='#94A3B8' size={20} />
                </div>
                <div className='mass-email-popup__title'>Create a Mass Email</div>
                <div className='mass-email-popup__dropdown-wrapper'>
                    <div className='mass-email-popup__each-dropdown'>
                        <div className='mass-email-popup__dropdown-label'>Status</div>
                        <select className='mass-email-popup__dropdown' onChange={(e) => setSelectedStatus(e.target.value)}>
                            <option default value=''>Select Status</option>
                            {statusOptions.map(option => <option key={option.id} value={option.label}>{option.label}</option>)}
                        </select>
                    </div>
                    <div className='mass-email-popup__each-dropdown'>
                        <div className='mass-email-popup__dropdown-label'>School (optional)</div>
                        <select className='mass-email-popup__dropdown' value={selectedSchool} onChange={(e) => setSelectedSchool(e.target.value)}>
                            <option default value=''>Select a school (optional)</option>
                            {schools.map(school => <option key={school.id} value={school.id}>{school.label}</option>)}
                        </select>
                    </div>
                    <div className='mass-email-popup__each-dropdown'>
                        <div className='mass-email-popup__dropdown-label'>Teacher</div>
                        <select className='mass-email-popup__dropdown' onChange={(e) => setSelectedTeacher(e.target.value)}>
                            <option default value=''>Select a {selectedSchool !== '' ? selectedSchool.toUpperCase() : null} teacher</option>
                            {alphabetizeTeachers(teachers).map(teacher => (teacher.Status !== 'Left School') && ((selectedSchool !== '') ? teacher.School === selectedSchool : true) && <option key={teacher.Name} value={teacher.TeacherID}>{teacher.Name}</option>)}
                        </select>
                    </div>
                    {/* <div className='mass-email-popup__each-dropdown'>
                        <div className='mass-email-popup__dropdown-label'>School</div>
                        <select className='mass-email-popup__dropdown' onChange={(e) => setSelectedSchool(e.target.value)}>
                            <option default value=''>Select School</option>
                            <option value='All Schools'>All Schools</option>
                            {schools.map(school => <option key={school.id} value={school.id}>{school.label}</option>)}
                        </select>
                    </div> */}
                    <div className='mass-email-popup__each-dropdown'>
                        <div className='mass-email-popup__dropdown-label'>Template</div>
                        <select className='mass-email-popup__dropdown'>
                            <option default value='teacher-evaluation'>Teacher Evaluation</option>
                        </select>
                    </div>
                </div>
                <div className='mass-email-popup__button-wrapper'>
                    <div></div>
                    <div className='mass-email-popup__continue-btn' onClick={() => setStep(2)}>
                        <div className='mass-email-popup__continue-btn__text'>Next</div>
                        <MdArrowForward size={14} />
                    </div>
                </div>
            </div>
            }
            {step === 2 &&
                <div>
                    <div className='mass-email-popup__close-wrapper'>
                        <MdClose onClick={() => setMassEmailPopup(false)} color='#94A3B8' size={20} />
                    </div>
                    <div className='mass-email-popup__title'>Create a Mass Email</div>
                    <div className='mass-email-popup__sub-title'>Please review the list below and make sure that these are the recipients you’d like to email.</div>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th>.</th>
                                    {tableDetails.map(detail => <th className='mass-email-popup__each-header' key={detail.value}>{detail.label.toUpperCase()}</th>)}
                                </tr>
                            </thead>
                            <tbody className='mass-email-popup__table-body'>
                                {filteredFamilies.map(student => 
                                    <tr key={student.familyId}>
                                        <td><MdClose onClick={() => removeFamily(student.familyId)} color='#94A3B8' size={20} /></td>
                                        {tableDetails.map((detail, index) => detail.editable ? 
                                            <td className='mass-email-popup__each-row' key={index}><input className='mass-email-popup__editable-input' onChange={(e) => editFamilyInformation(student.familyId, detail.value, e.target.value)} value={student[detail.value]} /></td> 
                                        : 
                                           <td className='mass-email-popup__each-row' key={index} style={detail.value === 'familyStatus' ? statusStyles(student.familyStatus) : null }>
                                                    {detail.value === 'findTeacher' ?
                                                    teachers.map((teacher) => teacher.TeacherID === selectedTeacher && <div className="student-db__teacher-chip"><img className="student-db__teacher-image" src={`https://app.atharo.app/images/${teacher.ImageName}`} alt="teachers" />{teacher.Name}</div>)
                                                        // calculateTeachersForFamily(student).map((teacher, i) => (i < 1 ? <div key={i} className="student-db__teacher-chip"><img className="student-db__teacher-image" src={teacher.image} alt="teachers" />{teacher.name && createEllipses(teacher.name, 15)}</div> : <div className="student-db__teacher-chip">+{calculateTeachersForFamily(student).length - 1}</div>) )
                                                    :
                                                        student[detail.value]
                                                    }
                                            </td>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className='mass-email-popup__button-wrapper'>
                        <div className='mass-email-popup__back-btn' onClick={() => setStep(1)}>
                            <MdArrowBack size={14} />
                            <div className='mass-email-popup__back-btn__text'>Back</div>
                        </div>
                        <div className='mass-email-popup__continue-btn' onClick={() => sendEmailWarning()}>Send Email</div>
                    </div>
                </div>
            }
        </div>
        }
        </div>
    )
}
export default MassEmailPopup